import { CommonModule } from '@angular/common';
import {
  Component,
  ElementRef,
  OnInit,
  QueryList,
  ViewChild,
  ViewChildren,
  booleanAttribute,
  computed,
  effect,
  input,
  model,
} from '@angular/core';
import { Icon } from '../icon/icon.component';
import { Color } from '../common/types';
import { BaseConfig } from '../common/config/config.adapter';

export type SegmentOption = {
  label: string;
  value: string;
  icon?: string;
  count?: number;
};

@Component({
  selector: 'app-segment',
  templateUrl: './segment.component.html',
  styleUrls: ['./segment.component.scss'],
  standalone: true,
  imports: [CommonModule, Icon],
})
export class Segment extends BaseConfig implements OnInit {
  @ViewChild('indicator') indicator!: ElementRef<HTMLDivElement>;
  @ViewChildren('item', { read: ElementRef })
  itemsRef!: QueryList<ElementRef<HTMLDivElement>>;

  color = input<Color>('primary');
  value = model<string>('');
  $options = input<string[] | SegmentOption[]>([], { alias: 'options' });

  options = computed<SegmentOption[]>(() => {
    if (this.$options().length === 0) return [];

    return this.$options().map((option) => {
      if (typeof option === 'string') {
        return {
          label: option,
          value: option,
        };
      }

      return option;
    });
  });

  scrollEnabled = input<boolean, string>(false, {
    transform: booleanAttribute,
  });

  constructor() {
    super();

    effect(
      () => {
        if (this.itemsRef && this.indicator && this.value()) {
          this.transform(this.value());
        }
      },
      { allowSignalWrites: true },
    );
  }

  ngOnInit(): void {
    if (!this.value()) {
      this.value.set(this.options()[0].value);
    }
  }

  handleClick(option: SegmentOption) {
    this.value.set(option.value);
  }

  transform(value: string) {
    const index = this.options().findIndex((item) => item.value === value);
    if (index === -1) return;
    this.indicator.nativeElement.style.width = `${this.itemsRef.toArray()[index].nativeElement.offsetWidth}px`;
    this.indicator.nativeElement.style.transform = `translateX(${this.getTranslateX(index)}px)`;
  }

  getTranslateX(index: number) {
    return this.itemsRef
      .toArray()
      .splice(0, index)
      .reduce((acc, cur) => acc + cur.nativeElement.offsetWidth, 0);
  }
}
